import { setPreparingExamsModal } from '../../store/workspace/slice';
import { CheckListSquareIcon } from '../../assets/icons';
import { useDispatch } from '../../store/store';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function PreparingExams() {
    const dispatch = useDispatch();

    const dismissFunc = () => {
        dispatch(setPreparingExamsModal(false));
    };

    return (
        <Modal
            size='sm'
            closeFunc={dismissFunc}
            icon={<CheckListSquareIcon />}
            childClassName={styles.wrapper}
            title='Your exams are almost ready'
            actions='confirm'
            confirmButton={{
                text: 'Ok',
                type: 'Primary',
                onClick: dismissFunc,
            }}
        >
            <p className={styles.description}>
                Our AI is still creating the exams for this job.
                This usually takes a few minutes.<br />
                Once they're ready, you can review, edit and publish your job post.
            </p>
        </Modal>
    )
}
